// @ts-nocheck
import React, { useEffect, useState, useContext } from "react";
import greenTick from "../../../assets/greenTick.png";
import redCrossTick from "../../../assets/redCrossTick.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./SubscriptionPlan.css";
import axios from "axios";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
export default function SubscriptionPlan() {
  const [plans, setPlans] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [active, setActive] = useState(0);
  const [durationFilter, setDurationFilter] = useState("monthly");
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const [activePlans, setActivePlans] = useState({
    condition: "",
    planId: null,
    planName: "",
    status: false,
    activatedSince: "N/A",
    amount: 0,
    duration: "",
    expiredAt: "N/A",
  });
  const isPlanActive = (plan) => {
    return (
      activePlans.status &&
      activePlans.condition === "Active" &&
      (activePlans.planId === plan._id ||
        activePlans.planId === plan.id || // Add this line
        activePlans.planName === plan.planName) &&
      activePlans.duration === (plan.duration || durationFilter)
    );
  };

  const getPlans = () => {
    setIsLoading(true);
    axios
      .get(`${COMPANY_URLS.getAllMonthlyPlans}?duration=${durationFilter}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        const allPlans = res?.data?.data || [];

        console.log("all plansssssssss", allPlans);
        setPlans(allPlans);
      })
      .catch((err) => {
        console.error("Error fetching plans:", err);
      })
      .finally(() => setIsLoading(false));
  };

  const choosePlan = (planId) => {
    console.log("plan id", planId);
    setIsLoading(true);
    axios
      .post(
        COMPANY_URLS.buyPlan,
        {
          id: planId,
          duration: durationFilter,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        let redirectUrl = res.data;

        if (typeof res.data === "object" && res.data !== null) {
          redirectUrl =
            res.data.url || res.data.paymentUrl || res.data.redirectUrl;
        }
        if (redirectUrl) {
          toast.success("Plan chosen successfully! Redirecting to payment...", {
            autoClose: 3000,
            onClose: () => {
              window.location.href = redirectUrl;
            },
          });
          window.location.href = redirectUrl;
        } else {
          console.error("No valid");
        }
      })
      .catch((err) => {
        console.error("Error selecting plan:", err);
      })
      .finally(() => setIsLoading(false));
  };

  const fetchActivePlan = async () => {
    try {
      const response = await axios.get(COMPANY_URLS.getActivePlan, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      });
      console.log("Full API response:", response);
      console.log("Response data structure active plan:", response.data);

      if (response.data && response.data.data) {
        const planData = response.data.data;
        console.log("Plan data:", planData);
        setActivePlans({
          planId: planData?._id || null,
          planName: planData?.planName || "Free plan",
          condition: planData?.condition || "",
          status: planData?.status || false,
          activatedSince: planData?.startedAt
            ? new Date(planData.startedAt).toLocaleDateString("en-US")
            : "N/A",
          amount: planData?.amount || 0,
          duration: planData?.duration || "monthly",
          expiredAt: planData?.expiredAt
            ? new Date(planData.expiredAt).toLocaleDateString("en-US")
            : "N/A",
        });
        console.log("Plan ID from API:", planData?._id);
        console.log(
          "Plan ID from plans array:",
          plans.find((p) => p._id === planData?._id)
        );
      } else {
        console.log("No active plan data found in response");
      }
    } catch (err) {
      console.error("Error fetching active plan:", err);
    }
  };

  const fetchInvoiceData = async () => {
    try {
      const response = await axios.get(COMPANY_URLS.getAllPayment, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      });
      const transformedData = response.data.data.map((item) => ({
        invoiceId: item.merchantTransactionId,
        date: new Date(item.createdAt).toLocaleDateString(),
        plan: item.planName,
        amount: item.amount,
        status: item.status,
        _id: item._id,
      }));

      setInvoiceData(transformedData);
    } catch (err) {
      console.error("Error", err);
    }
  };

  useEffect(() => {
    fetchActivePlan();
    fetchInvoiceData();
  }, []);

  useEffect(() => {
    getPlans();
  }, [durationFilter, activePlans]);
  return (
    <div className="subscriptionPlan_main mt-4">
      <h1 className="subs_heading">Subscription Plan</h1>
      <div className="subscri_plan d-flex flex-column gap-5">
        <div>
          <h1 className="mb-0 purchase_subs">Purchase a subscription</h1>
          <p className="mb-0">Choose the plan that works for you.</p>

          <div className="duration-toggle-container">
            <h3>{durationFilter === "yearly"}</h3>
            <div className="duration-toggle mt-3">
              <button
                className={`toggle-btn ${durationFilter === "monthly" ? "active" : ""
                  }`}
                onClick={() => setDurationFilter("monthly")}
                disabled={isLoading}
              >
                Monthly
              </button>
              <button
                className={`toggle-btn ${durationFilter === "yearly" ? "active" : ""
                  }`}
                onClick={() => setDurationFilter("yearly")}
                disabled={isLoading}
              >
                Yearly
              </button>
            </div>
          </div>
        </div>
        {plans?.length > 0 ? (
          <div className="offer_card_grp ">
            {plans?.map((plan, index) => (
              <div
                key={plan._id || index}
                className={`offer_card ${isPlanActive(plan) ? "enterprise-plan" : ""
                  } ${active === index && "active_offer_card"
                  } px-4 py-4 d-flex flex-column justify-content-between`}
              >
                <div>
                  <p>{plan?.planName}</p>
                  <div>
                    <span className="me-1">₹{plan?.price}</span>
                    <span>
                      /
                      {plan?.duration ||
                        (durationFilter === "yearly" ? "Year" : "Month")}
                    </span>
                    {durationFilter === "yearly" && plan.discount && (
                      <div className="text-success small mt-1">
                        Save {plan.discount}%
                      </div>
                    )}
                  </div>
                  <ul className="feature-list ps-0 mt-3">
                    <li>
                      <span className="tick_box">
                        <img src={greenTick} alt="included" />
                      </span>
                      <span>Job active for {plan?.jobActiveDays} days</span>
                    </li>
                    <li>
                      <span className="tick_box">
                        <img src={greenTick} alt="included" />
                      </span>
                      <span>
                        {plan?.postPerMonth} posts/
                        {durationFilter === "yearly" ? "year" : "month"}
                      </span>
                    </li>
                    <li>
                      <span className="tick_box">
                        <img src={greenTick} alt="included" />
                      </span>
                      <span>{plan?.members} members</span>
                    </li>
                    <li>
                      <span className="tick_box">
                        <img
                          src={plan?.whatsappNotify ? greenTick : redCrossTick}
                          alt={
                            plan?.whatsappNotify ? "included" : "not included"
                          }
                        />
                      </span>
                      <span>WhatsApp Notifications</span>
                    </li>
                    <li>
                      <span className="tick_box">
                        <img
                          src={
                            plan?.higherVisibility ? greenTick : redCrossTick
                          }
                          alt={
                            plan?.higherVisibility ? "included" : "not included"
                          }
                        />
                      </span>
                      <span>Higher visibility</span>
                    </li>
                    <li>
                      <span className="tick_box">
                        <img
                          src={
                            plan?.immediateHiringTag ? greenTick : redCrossTick
                          }
                          alt={
                            plan?.immediateHiringTag
                              ? "included"
                              : "not included"
                          }
                        />
                      </span>
                      <span>Immediate hiring tag</span>
                    </li>
                  </ul>
                </div>

                <button
                  className={`choose_plan ${index === 1 ? "white-choose-btn" : ""
                    } ${isPlanActive(plan) ? "active-plan-btn" : ""}`}
                  onClick={() =>
                    !isPlanActive(plan) && choosePlan(plan._id || plan.id)
                  }
                  disabled={isPlanActive(plan)}
                >
                  {isPlanActive(plan) ? "Active Plan" : "Choose Plan"}
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4">
            No {durationFilter} plans available
          </div>
        )}
      </div>
    </div>
  );
}
